<jni-bc-revenue-transactions
  [bcRevenueLists]="ytdgpList"
  [BCAvgMargin]="BCAvgMargin"
  [TotalBCCommission]="TotalBCCommission"
  [TotalBCGP]="TotalBCGP"
  [TotalBCReserve]="TotalBCReserve"
  [TotalBCRevenue]="TotalBCRevenue"
  [salesOrderNumberFilter]="salesOrderNumberFilter"
  (closeModalEvent)="onCloseModalEvent()"></jni-bc-revenue-transactions>
